import { getApiClient, initializeApiClient } from "../../../apiService";

export const AddJordanianGovernoratesProjectActivities = async (
  tG_JordanianGovernoratesNameId,
  tG_MainTargetedGroupId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TG_JordanianGovernoratesProjectActivities/AddTG_JordanianGovernoratesProjectActivities`,
    {
      tG_JordanianGovernoratesNameId: tG_JordanianGovernoratesNameId,
      tG_MainTargetedGroupId: tG_MainTargetedGroupId,
    }
  );

  return response;
};

export default AddJordanianGovernoratesProjectActivities;
